import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-4">欧美精品</h4>
            <p className="text-sm text-background-300 leading-relaxed">
              汇聚全球顶尖品牌，为您精选来自欧洲与美国的高端正品好物。品质有保障，服务更贴心。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-white transition-colors">首页</Link></li>
              <li><Link to="/categories" className="text-sm text-background-300 hover:text-white transition-colors">精选分类</Link></li>
              <li><Link to="/articles" className="text-sm text-background-300 hover:text-white transition-colors">品牌资讯</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-white transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">热门品类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/categories" className="text-sm text-background-300 hover:text-white transition-colors">时尚服饰</Link></li>
              <li><Link to="/categories" className="text-sm text-background-300 hover:text-white transition-colors">护肤美妆</Link></li>
              <li><Link to="/categories" className="text-sm text-background-300 hover:text-white transition-colors">生活家居</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-phone-line text-background-400"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line text-background-400"></i>
                <span>service@oumeijingpin.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-map-pin-line text-background-400"></i>
                <span>上海市静安区南京西路1688号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 欧美精品 版权所有 | 沪ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-white transition-colors" aria-label="微信"><i className="ri-wechat-line text-lg"></i></a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-white transition-colors" aria-label="微博"><i className="ri-weibo-line text-lg"></i></a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-white transition-colors" aria-label="小红书"><i className="ri-red-packet-line text-lg"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}